import { createSlice } from '@reduxjs/toolkit'


const initialState = false

const participantSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action) => action.payload
  }
})

export const { setLoading } = participantSlice.actions
export default participantSlice.reducer
